import Cookies from "js-cookie";

export const setCookie = (key: string, value: unknown, expiresDays = 1) => {
  if (typeof value === "string") {
    Cookies.set(key, value, {expires: expiresDays, secure: true, sameSite: "strict"});
    return;
  }
  Cookies.set(key, JSON.stringify(value), {expires: expiresDays, secure: true, sameSite: "strict"});
};

export const getCookie = <T = unknown>(key: string): T | null => {
  const value = Cookies.get(key);
  if (!value) {
    return null;
  }
  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
};

export const removeCookie = (key: string) => {
  Cookies.remove(key);
};
